import React from 'react';

import { InteractionFormDensity } from './interactionFormTokens';

export interface InteractionFormShellProps {
  /** The form's title. Falls back to the interaction name at the call site. */
  title: string;
  /** Renders the "Mandatory" chip when the template is mandatory. */
  isMandatory?: boolean;
  /**
   * Shown beside the title when a repeatable form tracks how many times it has
   * been completed (e.g. "2 of 3"). Omitted for non-repeatable forms.
   */
  countLabel?: string;
  density?: InteractionFormDensity;
  children: React.ReactNode;
}

export interface InteractionFieldBlockProps {
  label?: string;
  required?: boolean;
  /** Secondary guidance under the label. */
  helper?: string;
  /** Validation message. Rendered as an assertive live region when set. */
  error?: string;
  /**
   * Set for controls that render their own label (Checkbox, Radio, Label,
   * Presentation) so the same text never appears twice.
   */
  hideLabel?: boolean;
  children: React.ReactNode;
}

export enum InteractionNoticeSeverity {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

export interface InteractionNoticeProps {
  severity?: InteractionNoticeSeverity;
  children: React.ReactNode;
}
